// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\na[data-v-b2365b1c]{margin:0 8px;}\na span[data-v-b2365b1c]{font-size: 12px;background: #f44;border-radius: 4px;color: #fff;position: relative;text-align: center;min-width: 14px;top: -4px;display: inline-block;line-height: 14px;}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
